import type { Deal } from '@bcc/shared';
import { supabase } from './supabase';

/** First image: Supabase storage object path, or an absolute URL stored in `image_paths`. */
export function storageOrAbsoluteCoverUrl(paths: string[] | null | undefined): string | null {
  const path = paths?.[0];
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return supabase.storage.from('deal-assets').getPublicUrl(path).data.publicUrl;
}

/** Optional map for legacy demo card ids (e.g. `example-fl`) used when API has no rows. */
export function resolveDealCoverUrl(
  d: Deal,
  demoCoverByDealId?: Record<string, string>
): string | null {
  const demo = demoCoverByDealId?.[d.id];
  if (demo) return demo;
  return storageOrAbsoluteCoverUrl(d.image_paths);
}
